import React from "react";
import { VoidedTable } from "./view/VoidedTable";

interface Props {}

export const Voided: React.FC<Props> = () => {
  return (
    <>
      <VoidedTable />
    </>
  );
};
